export const getColorClass = (showColor: boolean, amount: string | number) => {
  if (showColor) {
    return Number(amount) > 0 ? ' income' : ' expense';
  }
  return '';
};

export const getColorName = (showColor: boolean, amount: string | number) => {
  if (showColor) {
    return Number(amount) > 0 ? 'green' : 'red';
  }
  return 'black';
};

export const getCurrencySymbol = ({ showCurrencySymbol, txn, getTxnCurrency }) =>
  showCurrencySymbol && txn.accountId ? getTxnCurrency(txn.accountId) : 'N/A';

export const QUEUE_PAYMENTS = ['QueuePmt'];
